/**
 * Gets 3P products that support a given filter, using the consolidated
 * ThirdPartyConfigs from rovo-connectors-config.
 *
 * This is intentionally in a separate file from filters/index.ts to avoid
 * pulling the 3P configs (and their icon-laden config files) into the
 * generateSearchInputs bundle. This file is only imported by UI filter
 * components, not by the generateSearchInputs call path.
 */
import { ThirdPartyConfigsSync as ThirdPartyConfigs } from '@atlassian/rovo-connectors-config/configs-sync';
import type { ProductKeys3P } from '@atlassian/rovo-connectors-config/types';
import type { FilterId as ConnectorsConfigFilterId } from '@atlassian/rovo-connectors-config/types/filters';

import type { FilterId } from '../../constants/filters';

export const getProducts3PFromConfigForFilter = (filterId: FilterId): ProductKeys3P[] => {
	const productsForFilter: ProductKeys3P[] = [];
	ThirdPartyConfigs.forEach((config, productKey3P) => {
		if (config.filters?.includes(filterId as ConnectorsConfigFilterId)) {
			productsForFilter.push(productKey3P);
		}
	});
	return productsForFilter;
};
